/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Checkbox, CheckboxChangeEvent } from 'antd';
import { Executive } from 'Types/PersonTypes';
import { backgroundColorParsing } from 'Utils/UtilityFunctions';
import DrawerPeopleMoveReason from 'Components/people/components/DrawerPeopleMoveReason';
import LazyTooltip, { LazyTooltipBoundary } from './LazyTooltip';
import PeopleWidgetWithOutHolo from './PeopleWidgetWithOutHolo';
import SmallButton from './SmallButton';

export type PersonListRowProps = {
  person: Executive,
  showSelectionCheckbox: boolean,
  isSelected: boolean,
  invertFollow: boolean,
  inGlobalSearch: boolean,
  openInNewTab: boolean,
  disableNavigation: boolean,
  followDisabled: boolean,
  onInfoClick: (person: Executive) => void,
  onPersonClick: (person: Executive) => void,
  onCheckboxChange: (person: Executive, e?: CheckboxChangeEvent) => void,
  onFollowClick: (person: Executive) => void,
};

const stopPropagation = (e: React.SyntheticEvent) => e.stopPropagation();

const getSelfPopupContainer = (e: HTMLElement) => e;

const getTooltipPopupContainer = () => document.querySelector('.triggers-bullet-tooltip') as HTMLElement;

const PersonListRow = function PersonListRow(props: PersonListRowProps) {
  const {
    person,
    showSelectionCheckbox,
    isSelected,
    invertFollow,
    inGlobalSearch,
    openInNewTab,
    disableNavigation,
    followDisabled,
    onInfoClick,
    onPersonClick,
    onCheckboxChange,
    onFollowClick,
  } = props;

  const handleInfoClick = () => onInfoClick(person);
  const handlePersonClick = () => onPersonClick(person);
  const handleCheckboxChange = (e: CheckboxChangeEvent) => onCheckboxChange(person, e);
  const handleFollowClick = () => onFollowClick(person);

  const isSelfCompany = person.companyId === 1880420;
  const tagText = isSelfCompany
    ? (person.location?.length ? person.location : person?.companyName)
    : person?.personDesignation
      ? person?.personDesignation : person?.headline;
  const companyText = isSelfCompany ? '' : person?.companyName;

  return (
    <LazyTooltipBoundary>
      <div
        className="people-container"
        onClick={handleInfoClick}
        onKeyDown={handleInfoClick}
        tabIndex={0}
        role="button"
      >
        {
        showSelectionCheckbox
          ? (
            <span
              role="presentation"
              className="person-checkbox"
              onClick={stopPropagation}
              onKeyDown={stopPropagation}
            >
              <Checkbox
                id={`person-checkbox-${person?.personId}`}
                checked={isSelected}
                className="checkbox-person-widget"
                onChange={handleCheckboxChange}
              />
            </span>
          )
          : null
      }
        <div
          className="person-info"
          onClick={handlePersonClick}
        >
          <div className="personImg">
            <PeopleWidgetWithOutHolo
              logo={person.personImage}
              persona={person.archeType.color}
              hidePersonality
              personality={person.archeType.name}
              wrapperColor={backgroundColorParsing(person.personalityTypes)}
              showRemoveIcon={false}
              showCheckBox={false}
              checked={false}
              personId={person.personId}
              diameter="42px"
              diameterXsm="26px"
              diameterSm="42px"
              ringPadding="2px"
              ringPaddingSm="2px"
              marginSm="0px"
              margin="0px"
              type={person?.personType}
              openInNewTab={openInNewTab}
              disableNavigation={disableNavigation}
              inGlobalSearch={inGlobalSearch}
            />
          </div>
          <div className="personName">
            <span
              role="button"
              tabIndex={0}
              aria-label={`view ${person.personName} profile`}
            >
              <div className="d-flex">
                <LazyTooltip
                  trigger="hover"
                  placement="top"
                  getPopupContainer={getSelfPopupContainer}
                  className="triggers-bullet-tooltip person-designation-tip"
                  color="#fff"
                  title={person.personName}
                  arrow={false}
                >
                  <span
                    className="person-name-here"
                    onClick={handleInfoClick}
                    onKeyDown={handleInfoClick}
                    tabIndex={0}
                    role="button"
                  >
                    {person?.personName}
                  </span>
                </LazyTooltip>
              </div>

              <div className="tagCompany">
                <LazyTooltip
                  arrow={false}
                  trigger="hover"
                  placement="topLeft"
                  getPopupContainer={getSelfPopupContainer}
                  className="triggers-bullet-tooltip person-designation-tip"
                  color="#fff"
                  title={tagText}
                >
                  <span
                    className="mb-0 person-tag-here"
                    onClick={handleInfoClick}
                    onKeyDown={handleInfoClick}
                    tabIndex={0}
                    role="button"
                  >
                    {tagText}
                  </span>
                </LazyTooltip>
                <LazyTooltip
                  arrow={false}
                  trigger="hover"
                  placement="top"
                  getPopupContainer={getTooltipPopupContainer}
                  className="triggers-bullet-tooltip person-designation-tip"
                  color="#fff"
                  title={companyText}
                >
                  <span
                    className="company-name-two person-company-here"
                    role="button"
                    tabIndex={0}
                    onClick={handleInfoClick}
                    onKeyPress={handleInfoClick}
                  >
                    {companyText}
                  </span>
                </LazyTooltip>
                {
                person?.personNotes ? (
                  <div
                    className="drawer-icon"
                    role="button"
                    tabIndex={0}
                    aria-label="button"
                    onClick={stopPropagation}
                    onKeyPress={stopPropagation}
                  >
                    <DrawerPeopleMoveReason
                      personId={person.personId}
                      showNotes
                      isPersonCard
                    />
                  </div>
                ) : (null)
              }
              </div>
            </span>
          </div>
        </div>
        <div
          className="d-flex justify-content-center follow-c-btn"
          role="button"
          tabIndex={0}
          aria-label="button"
          onClick={stopPropagation}
          onKeyPress={stopPropagation}
        >
          <SmallButton
            title={invertFollow ? (!person.personAdded ? 'Follow' : 'Unfollow') : (person.personAdded ? 'Unfollow' : 'Follow')}
            variant={invertFollow ? (!person.personAdded ? 'filled' : 'outlined') : (person.personAdded ? 'filled' : 'outlined')}
            color="#001760"
            padding={invertFollow ? (!person.personAdded ? '3px 11px' : '3px 5px') : (person.personAdded ? '3px 5px' : '3px 11px')}
            disabled={followDisabled}
            onButtonClick={handleFollowClick}
          />
        </div>
      </div>
    </LazyTooltipBoundary>
  );
};

export default React.memo(PersonListRow);
